import React, { useEffect, useRef } from 'react';
import { heroImages } from '../data/mock';

const HeroSection = ({ onContactClick }) => {
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const row3Ref = useRef(null);

  // Create extended image arrays for infinite scroll feel
  const allImages = [...heroImages, ...heroImages, ...heroImages];

  // Split into 3 rows
  const row1 = allImages.slice(0, Math.ceil(allImages.length / 3));
  const row2 = allImages.slice(Math.ceil(allImages.length / 3), Math.ceil(allImages.length * 2 / 3));
  const row3 = allImages.slice(Math.ceil(allImages.length * 2 / 3));

  return (
    <section style={{
      position: 'relative',
      width: '100%',
      height: '100vh',
      backgroundColor: '#000',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {/* Image Mosaic Background */}
      <div style={{
        position: 'absolute',
        inset: '-100px',
        transform: 'rotate(-8deg) scale(1.3)',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        opacity: 0.7,
      }}>
        {/* Row 1 - scroll left */}
        <div style={{ display: 'flex', gap: '8px', animation: 'scrollLeft 35s linear infinite' }}>
          {[...row1, ...row1].map((img, i) => (
            <div key={i} style={{
              flexShrink: 0,
              width: '220px',
              height: '280px',
              borderRadius: '14px',
              overflow: 'hidden',
              backgroundColor: '#111',
            }}>
              <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          ))}
        </div>
        {/* Row 2 - scroll right */}
        <div style={{ display: 'flex', gap: '8px', animation: 'scrollRight 40s linear infinite', marginLeft: '-80px' }}>
          {[...row2, ...row2].map((img, i) => (
            <div key={i} style={{
              flexShrink: 0,
              width: '220px',
              height: '280px',
              borderRadius: '14px',
              overflow: 'hidden',
              backgroundColor: '#111',
            }}>
              <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          ))}
        </div>
        {/* Row 3 - scroll left */}
        <div style={{ display: 'flex', gap: '8px', animation: 'scrollLeft 45s linear infinite', marginLeft: '-40px' }}>
          {[...row3, ...row3].map((img, i) => (
            <div key={i} style={{
              flexShrink: 0,
              width: '220px',
              height: '280px',
              borderRadius: '14px',
              overflow: 'hidden',
              backgroundColor: '#111',
            }}>
              <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          ))}
        </div>
        {/* Row 4 - scroll right */}
        <div style={{ display: 'flex', gap: '8px', animation: 'scrollRight 30s linear infinite', marginLeft: '-120px' }}>
          {[...row1, ...row1].map((img, i) => (
            <div key={i} style={{
              flexShrink: 0,
              width: '220px',
              height: '280px',
              borderRadius: '14px',
              overflow: 'hidden',
              backgroundColor: '#111',
            }}>
              <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          ))}
        </div>
      </div>

      {/* Dark Overlay */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.45) 50%, rgba(0,0,0,0.65) 100%)',
        zIndex: 1,
      }} />

      {/* Hero Content */}
      <div style={{
        position: 'relative',
        zIndex: 2,
        textAlign: 'center',
        padding: '0 20px',
        maxWidth: '900px',
      }}>
        <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontFamily: "'Figtree', sans-serif",
          fontSize: '13px',
          fontWeight: '500',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          marginBottom: '24px',
        }}>
          Project Manager · Sports & Government Advisor · Leadership Strategist
        </p>

        <h1 style={{
          color: '#ffffff',
          fontFamily: "'Climate Crisis', sans-serif",
          fontSize: 'clamp(40px, 7vw, 80px)',
          fontWeight: '400',
          lineHeight: '1.05',
          letterSpacing: '0em',
          margin: '0 0 28px 0',
        }}>
          Structure. Leadership.<br />Measurable Results.
        </h1>

        <p style={{
          color: 'rgba(255,255,255,0.7)',
          fontFamily: "'Figtree', sans-serif",
          fontSize: 'clamp(15px, 2vw, 18px)',
          fontWeight: '400',
          lineHeight: '1.7',
          marginBottom: '44px',
          maxWidth: '600px',
          margin: '0 auto 44px',
        }}>
          I work where sports, government, leadership, and performance intersect.<br />
          I don't sell ideas. I build systems that win.
        </p>

        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => {
              const el = document.querySelector('#services');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            style={{
              background: '#C8102E',
              color: '#ffffff',
              border: 'none',
              borderRadius: '100px',
              padding: '14px 32px',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '14px',
              fontWeight: '700',
              letterSpacing: '0.04em',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'background-color 0.2s ease, transform 0.2s ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#a80d25'; e.currentTarget.style.transform = 'scale(1.03)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C8102E'; e.currentTarget.style.transform = 'scale(1)'; }}
          >
            Work With Me
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M3 11L11 3M11 3H5M11 3V9" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button
            onClick={onContactClick}
            style={{
              background: 'transparent',
              color: '#ffffff',
              border: '1px solid rgba(255,255,255,0.4)',
              borderRadius: '100px',
              padding: '14px 32px',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '14px',
              fontWeight: '600',
              letterSpacing: '0.04em',
              cursor: 'pointer',
              transition: 'border-color 0.2s ease, background-color 0.2s ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.8)'; e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'; e.currentTarget.style.backgroundColor = 'transparent'; }}
          >
            Book a Strategy Call
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div style={{
        position: 'absolute',
        bottom: '32px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        animation: 'bounceDown 2s ease-in-out infinite',
      }}>
        <span style={{
          color: 'rgba(255,255,255,0.4)',
          fontFamily: "'Figtree', sans-serif",
          fontSize: '11px',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
        }}>Scroll</span>
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
          <path d="M8 2v14M2 12l6 6 6-6" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      <style>{`
        @keyframes scrollLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes scrollRight {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        @keyframes bounceDown {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50% { transform: translateX(-50%) translateY(6px); }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
